import React from 'react';
import type { TFunction } from 'i18next';
import { STEPPER_ACTIVE_GRADIENT, STEPPER_ACTIVE_SHADOW } from '../constants';

export interface StepperProps {
  hasPayroll: boolean;
  t: TFunction;
}

export function Stepper({ hasPayroll, t }: StepperProps): React.ReactElement {
  const steps = [
    { n: "1", label: t("common.steps.selectedPlan"), state: "done" as const },
    { n: "2", label: hasPayroll ? t("common.steps.addedPayroll") : t("common.steps.skippedPayroll"), state: "done" as const },
    { n: "3", label: t("common.steps.reviewOrder"), state: "active" as const },
  ];
  return (
    <span className="inline-flex flex-wrap items-center gap-4">
      {steps.map((s, i) => (
        <React.Fragment key={i}>
          {i > 0 && <div className={"h-0.5 w-8 rounded " + (s.state === "done" ? "bg-brand" : "bg-stroke")} />}
          <div className="flex items-center gap-2">
            <div
              className={"flex items-center justify-center rounded-full font-extrabold " + (s.state === "active" ? "text-white" : "text-brand") + " " + (s.state === "done" ? "border-2 border-brand bg-white" : "border-none")}
              style={{
                width: s.state === "active" ? 30 : 28,
                height: s.state === "active" ? 30 : 28,
                fontSize: 13,
                background: s.state === "active" ? STEPPER_ACTIVE_GRADIENT : (s.state === "done" ? "white" : "white"),
                boxShadow: s.state === "active" ? STEPPER_ACTIVE_SHADOW : "none",
              }}
            >{s.state === "done" ? "✓" : s.n}</div>
            <span className={"text-small " + (s.state === "active" ? "font-extrabold text-ink" : "font-semibold")} style={{ color: s.state === "active" ? undefined : "#374151" }}>{s.label}</span>
          </div>
        </React.Fragment>
      ))}
    </span>
  );
}
